import React from 'react';
import './contact.css';
import PlaceholderThumb from '../../../thumb/PlaceholderThumb';

const contact = (props) => {
  let unreadCount = props.unread.length === 0 ? null : props.unread[0].count;

  return (
    <div onClick={props.contactModalOpen} className="contact">
      <div name="contact-notification">
        {
          unreadCount !== null &&
          <div><span>{unreadCount}</span></div>
        }
      </div>
      <div className="contactImage">
        { props.contactPhoto===null ? 
          <div className="default-image">
            <PlaceholderThumb
              firstName={props.firstName}
              lastName={props.lastName}
              size={15}
              contactDefaultPhoto={props.contactDefaultPhoto}
            />
          </div>
          : <img src={props.contactPhoto} alt='' />
        }
      </div>
      <div className="contactName noselect">{props.firstName +" " + props.lastName}</div>
      {props.contactOnline && <div className="contactOnline"></div>}
      {/* <div className="contactTime noselect">{props.contactTime}</div> */}
    </div>
  )
}

export default contact;


// WEBPACK FOOTER //
// ./src/common/chat/contactWindow/contact/contact.js